import Image from "@Components/Image";
import styles from "./StepCard.module.scss";
import config from "@Config/index";
import wrapperHOC from "@Utils/wrapperHOC";

const StepCard = ({ stepNumber, imgSrc, title, subTitle, showArrow, isDesktop = false }: any) => (
  <>
    <div className={styles.stepCardOuter}>
      <div
        className={isDesktop ? styles.stepCardInnerDesktop : styles.stepCardInner}
        data-testid={title}
      >
        <div className={styles.stepNumber}>{stepNumber}</div>
        <Image
          src={imgSrc}
          height={isDesktop ? 46 : 42}
          width={isDesktop ? 46 : 42}
          className={styles.image}
          alt={title}
        />
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.subTitle}>{subTitle}</div>
      </div>
      {showArrow && (
        <Image
          src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/step-arrow-right.svg`}
          height={isDesktop ? 20 : 6}
          width={isDesktop ? 80 : 25.2}
          className={styles.icon}
          alt=""
        />
      )}
    </div>
  </>
);

export default wrapperHOC(StepCard, {
  componentName: "StepCard-ThreeStepsSection-Home",
  showForChina: true,
});
